












































































































































































// decoradores
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
// tipos
import {HeadersDataTable} from "@/typings/vuetify/vDataTable";
import { Legal } from "@/typings/store/plugins/easyFirestore/legales";
import {ItemsTablaLegales} from "@/typings/components/legales/tabla";
import "@/helpers/extensions";

@Component
export default class TablaLegales extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly legales!: Array<Legal>;

  options = {
    itemsPerPage: -1,
  };
  headerProps = {
    sortIcon: "mdi-chevron-down"
  }

  get headers(): HeadersDataTable {
    return [
      //{text: "", value: "estado", sortable: false},
      {text: "Nombre", value: "nombre"},
      {text: "Posicion", value: "posicion"},
      {text: "", value: "opciones", sortable: false}
    ];
  }

  get items(): ItemsTablaLegales {
    return this.legales.map((legal) => {
      const nombre = legal.nombre;
      const posicion = legal.posicion;
    
      return {
        nombre,
        posicion,
       
        data: legal,
      };
    });
  }

//   actualizarEstado(item: Usuario): void {
//     let estado: EstadoUsuario;
//     item.estado === 'libre' ? estado = 'bloqueado' : estado = 'libre';
//     item.estado = estado;
//     this.onCambiarEstado(item);
//   }

//   @Emit("cambiar-estado")
//   onCambiarEstado(usuario: Usuario): Usuario {
//     return usuario;
//   }

  @Emit("abrir-info")
  onAbrirInfo(legal: Legal): Legal {
    return legal;
  }

  @Emit("abrir-editar")
  onAbrirEditar(legal: Legal): Legal {
    return legal;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(legal: Legal): Legal {
    return legal;
  }
}
